import React, { useEffect, useState } from 'react'
import { database, ref, get, set, remove } from '../firebase'
import { useNavigate } from 'react-router-dom';
// Eye icons as SVG components
const EyeIcon = ({ visible, onClick }) => (
  <span onClick={onClick} style={{ cursor: 'pointer', marginLeft: 8 }}>
    {visible ? (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
    ) : (
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a9.956 9.956 0 012.293-3.95m3.362-2.675A9.956 9.956 0 0112 5c4.478 0 8.268 2.943 9.542 7a9.965 9.965 0 01-4.293 5.03M15 12a3 3 0 11-6 0 3 3 0 016 0zm-6.364 6.364L19.07 4.93" /></svg>
    )}
  </span>
);

const Adminprofile = () => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({ adminName: '', mobile: '' });
  const [updating, setUpdating] = useState(false);
  const [changePwdMode, setChangePwdMode] = useState(false);
  const [pwdForm, setPwdForm] = useState({ current: '', newPwd: '', confirmPwd: '' });
  const [pwdUpdating, setPwdUpdating] = useState(false);
  const [pwdError, setPwdError] = useState('');
  const [showPwd, setShowPwd] = useState({ current: false, newPwd: false, confirmPwd: false });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (!currentUser || !currentUser.mobile) {
          setError('No admin logged in.');
          setLoading(false);
          return;
        }
        const adminRef = ref(database, `/videoplayer/Users/${currentUser.mobile}`);
        const snapshot = await get(adminRef);
        if (snapshot.exists()) {
          setAdmin(snapshot.val());
          setForm({
            adminName: snapshot.val().adminName || snapshot.val().fullName || '',
            mobile: snapshot.val().mobile || '',
          });
          setPwdForm((prev) => ({ ...prev, current: snapshot.val().password || '' }));
        } else {
          setError('Admin profile not found.');
        }
      } catch (err) {
        setError('Failed to fetch admin profile.');
      }
      setLoading(false);
    };
    fetchAdmin();
  }, []);

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setUpdating(true);
    setError('');
    try {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (!currentUser || !currentUser.mobile) {
        setError('No admin logged in.');
        setUpdating(false);
        return;
      }
      const oldMobile = currentUser.mobile;
      const newMobile = form.mobile;
      const adminRef = ref(database, `/videoplayer/Users/${oldMobile}`);
      const snapshot = await get(adminRef);
      if (!snapshot.exists()) {
        setError('Admin profile not found.');
        setUpdating(false);
        return;
      }
      const adminData = snapshot.val();
      const updatedData = {
        ...adminData,
        adminName: form.adminName,
        mobile: newMobile,
      };
      if (oldMobile !== newMobile) {
        // Move node: set new, remove old
        const newRef = ref(database, `/videoplayer/Users/${newMobile}`);
        await set(newRef, updatedData);
        await remove(adminRef);
        localStorage.setItem('currentUser', JSON.stringify({ ...currentUser, adminName: form.adminName, mobile: newMobile }));
      } else {
        await set(adminRef, updatedData);
        localStorage.setItem('currentUser', JSON.stringify({ ...currentUser, adminName: form.adminName }));
      }
      setAdmin(updatedData);
      setEditMode(false);
    } catch (err) {
      setError('Failed to update profile.');
    }
    setUpdating(false);
  };

  const handlePwdChange = (e) => {
    setPwdForm({ ...pwdForm, [e.target.name]: e.target.value });
    setPwdError('');
  };

  const handlePwdUpdate = async (e) => {
    e.preventDefault();
    setPwdUpdating(true);
    setPwdError('');
    if (!pwdForm.newPwd || !pwdForm.confirmPwd) {
      setPwdError('Please fill all fields.');
      setPwdUpdating(false);
      return;
    }
    if (pwdForm.newPwd !== pwdForm.confirmPwd) {
      setPwdError('Passwords do not match.');
      setPwdUpdating(false);
      return;
    }
    try {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (!currentUser || !currentUser.mobile) {
        setPwdError('No admin logged in.');
        setPwdUpdating(false);
        return;
      }
      const adminRef = ref(database, `/videoplayer/Users/${currentUser.mobile}`);
      const snapshot = await get(adminRef);
      if (!snapshot.exists()) {
        setPwdError('Admin profile not found.');
        setPwdUpdating(false);
        return;
      }
      const adminData = snapshot.val();
      await set(adminRef, { ...adminData, password: pwdForm.newPwd });
      setPwdForm({ current: pwdForm.newPwd, newPwd: '', confirmPwd: '' });
      setChangePwdMode(false);
    } catch (err) {
      setPwdError('Failed to update password.');
    }
    setPwdUpdating(false);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-md mx-auto mt-10 p-6 bg-red-50 rounded-lg shadow">
        <div className="text-red-600 font-medium text-center">{error}</div>
      </div>
    );
  }

  if (!admin) return null;

  if (changePwdMode) {
    return (
      <div className="w-full px-2 sm:px-4 flex justify-center">
        <div className="w-full max-w-md sm:max-w-lg my-6 sm:my-10 bg-white rounded-xl shadow-md overflow-hidden">
          <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-4 sm:p-6 text-white flex items-center">
            <button onClick={() => navigate(-1)} className="mr-2 sm:mr-4 focus:outline-none" title="Back">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
            </button>
            <h2 className="text-lg sm:text-2xl font-bold text-center flex-1">Change Password</h2>
          </div>
          <form className="p-4 sm:p-6" onSubmit={handlePwdUpdate}>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">Current Password</label>
              <div className="relative">
                <input
                 type={showPwd.current ? 'text' : 'password'}
                  name="current"
                  value={pwdForm.current}
                  readOnly
                  className="w-full px-3 py-2 border rounded-lg bg-gray-100 text-gray-500 cursor-not-allowed pr-10"
                />
               <span className="absolute inset-y-0 right-3 flex items-center">
                 <EyeIcon visible={showPwd.current} onClick={() => setShowPwd(s => ({ ...s, current: !s.current }))} />
               </span>
              </div>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">New Password</label>
              <div className="relative">
                <input
                 type={showPwd.newPwd ? 'text' : 'password'}
                  name="newPwd"
                  value={pwdForm.newPwd}
                  onChange={handlePwdChange}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring pr-10"
                  required
                />
               <span className="absolute inset-y-0 right-3 flex items-center">
                 <EyeIcon visible={showPwd.newPwd} onClick={() => setShowPwd(s => ({ ...s, newPwd: !s.newPwd }))} />
               </span>
              </div>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">Confirm Password</label>
              <div className="relative">
                <input
                 type={showPwd.confirmPwd ? 'text' : 'password'}
                  name="confirmPwd"
                  value={pwdForm.confirmPwd}
                  onChange={handlePwdChange}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring pr-10"
                  required
                />
               <span className="absolute inset-y-0 right-3 flex items-center">
                 <EyeIcon visible={showPwd.confirmPwd} onClick={() => setShowPwd(s => ({ ...s, confirmPwd: !s.confirmPwd }))} />
               </span>
              </div>
            </div>
            {pwdError && <div className="text-red-600 mb-2 text-center">{pwdError}</div>}
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 mt-6">
              <button
                type="submit"
                className="w-full sm:flex-1 bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-lg transition duration-200"
                disabled={pwdUpdating}
              >
                {pwdUpdating ? 'Updating...' : 'Update Password'}
              </button>
              <button
                type="button"
                className="w-full sm:flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium py-2 px-4 rounded-lg transition duration-200"
                onClick={() => setChangePwdMode(false)}
                disabled={pwdUpdating}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  if (editMode) {
    return (
      <div className="w-full px-2 sm:px-4 flex justify-center">
        <div className="w-full max-w-md sm:max-w-lg my-6 sm:my-10 bg-white rounded-xl shadow-md overflow-hidden">
          <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-4 sm:p-6 text-white flex items-center">
            <button onClick={() => navigate(-1)} className="mr-2 sm:mr-4 focus:outline-none" title="Back">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
            </button>
            <h2 className="text-lg sm:text-2xl font-bold text-center flex-1">Edit Admin Profile</h2>
          </div>
          <form className="p-4 sm:p-6" onSubmit={handleUpdate}>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">Admin Name</label>
              <input
                type="text"
                name="adminName"
                value={form.adminName}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring"
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">Mobile Number</label>
              <input
                type="text"
                name="mobile"
                value={form.mobile}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring"
                required
              />
            </div>
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 mt-6">
              <button
                type="submit"
                className="w-full sm:flex-1 bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-lg transition duration-200"
                disabled={updating}
              >
                {updating ? 'Updating...' : 'Update'}
              </button>
              <button
                type="button"
                className="w-full sm:flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium py-2 px-4 rounded-lg transition duration-200"
                onClick={() => setEditMode(false)}
                disabled={updating}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full px-2 sm:px-4 flex justify-center">
      <div className="w-full max-w-md sm:max-w-lg my-6 sm:my-10 bg-white rounded-xl shadow-md overflow-hidden">
        <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-4 sm:p-6 text-white flex items-center">
          <button onClick={() => navigate(-1)} className="mr-2 sm:mr-4 focus:outline-none" title="Back">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
          </button>
          <h2 className="text-lg sm:text-2xl font-bold text-center flex-1">Admin Profile</h2>
        </div>
        <div className="p-4 sm:p-6">
          <div className="mb-4 pb-4 border-b border-gray-200">
            <div className="flex items-center space-x-4">
              <div className="flex-shrink-0">
                <div className="h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-lg sm:text-xl">
                  {admin.adminName?.charAt(0) || admin.fullName?.charAt(0) || 'A'}
                </div>
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-semibold text-gray-800">
                  {admin.adminName || admin.fullName || 'N/A'}
                </h3>
                <p className="text-gray-600 capitalize text-sm sm:text-base">{admin.role}</p>
              </div>
            </div>
          </div>
          <div className="space-y-4">
            <div className="flex items-center">
              <svg className="h-5 w-5 text-gray-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <span className="text-gray-700 text-sm sm:text-base">{admin.mobile}</span>
            </div>
            {admin.email && (
              <div className="flex items-center">
                <svg className="h-5 w-5 text-gray-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span className="text-gray-700 text-sm sm:text-base">{admin.email}</span>
              </div>
            )}
            <div className="flex items-center">
              <svg className="h-5 w-5 text-gray-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span className="text-gray-700 capitalize text-sm sm:text-base">{admin.role}</span>
            </div>
          </div>
          <div className="mt-6 pt-4 border-t border-gray-200 flex flex-col gap-2">
            <button className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-lg transition duration-200" onClick={handleEdit}>
              Edit Profile
            </button>
            <button className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-medium py-2 px-4 rounded-lg transition duration-200" onClick={() => setChangePwdMode(true)}>
              Change Password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Adminprofile;